import {
  PROJECT_CHANGE_ACTIVE_FILTER_STATUS,
  PROJECT_CLEAR_SELECTED_PROJECT,
  PROJECT_CLOSE,
  PROJECT_CREATE,
  PROJECT_EDIT,
  PROJECT_ERROR,
  PROJECT_FETCHING_DATA,
  PROJECT_GET_COMPANY,
  PROJECT_GET_NEW_DATA,
  PROJECT_GET_OPENED,
  PROJECT_INDEX,
  PROJECT_OPEN,
  PROJECT_PROGRESS,
  PROJECT_SELECT,
  PROJECT_SHOW,
} from "../../old/typesAction";

const INITIAL_STATE = {
  projects: [],
  open_projects: [],
  errorMessage: null,
  inProgress: true,
  totalItems: 0,
  filters: [],
  selectedProject: {},
  selectedProjectObj: null,
  progress: {},
  currentProject: {},
};

// Split reducers https://redux.js.org/basics/reducers
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case PROJECT_INDEX:
      return {
        ...state,
        filters: action.payload.filters,
        projects: action.payload.data["hydra:member"],
        totalItems: action.payload.data["hydra:totalItems"],
        //viewControll: action.payload.data["hydra:view"],
        errorMessage: null,
        inProgress: false,
      };
    case PROJECT_SHOW:
      return {
        ...state,
        currentProject: action.payload,
        errorMessage: null,
        inProgress: false,
      };
    case PROJECT_GET_COMPANY:
      return { ...state, errorMessage: null, inProgress: false };
    case PROJECT_CREATE:
      return { ...state, errorMessage: null, inProgress: false };
    case PROJECT_EDIT:
      return { ...state, errorMessage: null, inProgress: false };
    case PROJECT_GET_NEW_DATA:
      return {
        ...state,
        projects: action.payload["hydra:member"],
        totalItems: action.payload["hydra:totalItems"],
        //viewControll: action.payload["hydra:view"],
        errorMessage: null,
        inProgress: false,
      };
    case PROJECT_ERROR:
      return {
        ...state,
        errorMessage: action.payload.response?.data,
        inProgress: false,
      };
    case PROJECT_FETCHING_DATA:
      return { ...state, inProgress: action.payload, errorMessage: null };
    case PROJECT_CHANGE_ACTIVE_FILTER_STATUS:
      return {
        ...state,
        filters: state.filters.map((filter) => {
          if (filter.propertyName === action.payload.propertyName) {
            filter.isActive = !filter.isActive;
          }
          return filter;
        }),
      };
    case PROJECT_GET_OPENED:
      return {
        ...state,
        open_projects: action.payload,
        errorMessage: null,
        // inProgress: false
      };
    case PROJECT_OPEN:
      const { data, id } = action.payload;
      return {
        ...state,
        selectedProject: id,
        selectedProjectObj: data.find((el) => el.id === id),
        open_projects: data,
        errorMessage: null,
      };
    case PROJECT_CLOSE:
      return {
        ...state,
        open_projects: action.payload.data,
        selectedProject: action.payload.selected_project,
        selectedProjectObj: action.payload.selected_project_obj,
        errorMessage: null,
      };
    case PROJECT_SELECT:
      return {
        ...state,
        selectedProject: action.payload.id,
        selectedProjectObj: action.payload,
      };
    case PROJECT_CLEAR_SELECTED_PROJECT:
      return {
        ...state,
        selectedProject: action.payload,
        selectedProjectObj: action.payload,
      };
    case PROJECT_PROGRESS:
      return { ...state, progress: action.payload };
    default:
      return state;
  }
}
